import {
    Col,
    message,
    PageHeader,
    Row,
    Spin,
    Select,
    Space,
    Tabs,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
import {
    SelectItem,
    Form,
    FormItem,
    cuentaMask,
    TableItem,
    RangePickerItem,
    ButtonItem,
    ErrorItem
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment/locale/es";
import reporteDeActividadesEtapaPdf from "../../../../Pdf/reporteDeActividadesEtapaPdf";

moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteActividadEtapas extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        pdf: null,
        objetoProyectos: null,
        todasProyectos: null,
        objetoUniadesDeNegocio: null,
        todasUniadesDeNegocio: null,
        dataReporte: null,
        todasActividades: [],
        objetoCuentaContable: null,
        todasCuentaContable: null,
    };

    atras() {
        this.props.history.goBack();
    }

    async componentDidMount() {
        this.setState({ loading: true });
        await axios
            .post(
                "proyectos/selectProyectos",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({ todasProyectos: res.data });
                    this.setState({
                        objetoProyectos: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });
        await axios
            .post(
                "unidadesdenegocio/selectUnidadesDeNegocio",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({ todasUniadesDeNegocio: res.data });
                    this.setState({
                        objetoUniadesDeNegocio: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {cuentaMask(
                                        value.nivel1 +
                                        value.nivel2 +
                                        value.nivel3 +
                                        value.nivel4 +
                                        value.nivel5
                                    ) +
                                        " - " +
                                        value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });

        let primerEtapa = null

        await axios
            .post(
                "etapas/selectEtapas",
                { empresaId: this.props.empresaId },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    primerEtapa = res.data.etapas[0]?._id || null
                    const etapas = res.data.etapas.map((etapa) => (
                        <Option key={etapa._id} value={etapa._id}>
                            {etapa.nombre}
                        </Option>
                    ));
                    this.setState({
                        objetoEtapas: etapas,
                    });
                } else if (res.data.success === 1) {
                    this.setState({ loading: false });
                    message.warning(res.data.message);
                } else {
                    this.setState({ loading: false });
                    message.error("Hubo un error al consultar las etapas.");
                }
            })


        this.formRef.current.setFieldsValue({
            periodo: [moment().subtract(1, "month"), moment()],
            etapaId: primerEtapa
        });

        this.consultarReporteActividadEtapas({
            periodo: [moment().subtract(1, "month"), moment()],
            etapaId: primerEtapa
        });
    }

    consultarReporteActividadEtapas(values) {
        this.setState({ loading: true });
        axios
            .post(
                "reportesActividades/reporteActividadEtapas",
                { ...values, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        loading: false,
                        dataReporte: res.data,
                        todasActividades: res.data.actividades,
                    });
                } else if (res.data.success === 1) {
                    message.error("Ha sucedido un error y no se cargo bien el reporte");
                } else {
                    message.error("Ha sucedido un error y no se cargo bien el reporte");
                }
                this.setState({ loading: false });
            });
    }

    descargarExcel() {
        let datosDescargar = [];

        for (const valueCA of this.state.todasActividades) {
            datosDescargar.push({
                Numero: valueCA.numero,
                Insumo: valueCA.insumoNombre,
                "Fecha Inicio": valueCA.fechaInicio ? moment(valueCA.fechaInicio).locale("es").format("L") : "",
                "Fecha Final": valueCA.fechaFinal ? moment(valueCA.fechaFinal).locale("es").format("L") : "",
                Empleados: valueCA.empleadosNombre,
                Concepto: valueCA.concepto,
                Estado: valueCA.estadoActividad === 0 ? "Cancelado" : valueCA.estadoActividad === 1 ? "Sin estado" : valueCA.estadoActividad === 2 ? "En proceso" : valueCA.estadoActividad === 3 ? "Terminado" : "",
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(datosDescargar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Estado de Cuenta");
        //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
        //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
        XLSX.writeFile(
            workbook,
            `Actividad_Etapas_${moment().locale("es").format("L")}.xlsx`
        );
    }

    descargarPdf() {
        pdfMake
            .createPdf(reporteDeActividadesEtapaPdf(this.state.dataReporte))
            .download(`Actividad_Etapas_${moment().locale("es").format("L")}`);
    }

    onFinishFailed(e) {
        ErrorItem(e);
    }

    render() {
        const columns = [
            {
                title: "Numero",
                dataIndex: "numero",
                key: "numero",
                sorter: (a, b) => {
                    if (a.numero < b.numero) {
                        return -1;
                    }
                    if (a.numero > b.numero) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "numero",
                ellipsis: true,
                width: '25%'
            },
            {
                title: "Insumo",
                dataIndex: "insumoNombre",
                key: "insumoNombre",
                sorter: (a, b) => {
                    if (a.insumoNombre < b.insumoNombre) {
                        return -1;
                    }
                    if (a.insumoNombre > b.insumoNombre) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "insumoNombre",
                ellipsis: true,
                width: '25%'
            },
            {
                title: "Fecha Inicio",
                dataIndex: "fechaInicio",
                key: "fechaInicio",
                sorter: (a, b) => {
                    if (moment(a.fechaInicio) < moment(b.fechaInicio)) {
                        return -1;
                    }
                    if (moment(a.fechaInicio) > moment(b.fechaInicio)) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => value ? moment(value).locale('es').format('L') : "",
                buscar: "fechaInicio",
                ellipsis: true,
                width: '10%'
            },
            {
                title: "Fecha Final",
                dataIndex: "fechaFinal",
                key: "fechaFinal",
                sorter: (a, b) => {
                    if (moment(a.fechaFinal) < moment(b.fechaFinal)) {
                        return -1;
                    }
                    if (moment(a.fechaFinal) > moment(b.fechaFinal)) {
                        return 1;
                    }
                    return 0;
                },
                render: (value) => value ? moment(value).locale('es').format('L') : "",
                buscar: "fechaFinal",
                ellipsis: true,
                width: '10%'
            },
            {
                title: "Empleados",
                dataIndex: "empleadosNombre",
                key: "empleadosNombre",
                sorter: (a, b) => {
                    if (a.empleadosNombre < b.empleadosNombre) {
                        return -1;
                    }
                    if (a.empleadosNombre > b.empleadosNombre) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "empleadosNombre",
                ellipsis: true,
                width: '25%'
            },
            {
                title: "Concepto",
                dataIndex: "concepto",
                key: "concepto",
                sorter: (a, b) => {
                    if (a.concepto < b.concepto) {
                        return -1;
                    }
                    if (a.concepto > b.concepto) {
                        return 1;
                    }
                    return 0;
                },
                buscar: "concepto",
                ellipsis: true,
                width: '25%'
            },
            {
                title: "Estado",
                dataIndex: "estadoActividad",
                key: "estadoActividad",
                render: (value) => {
                    if (value === 0) return "Cancelado";
                    if (value === 1) return "Sin estado";
                    if (value === 2) return "En proceso";
                    if (value === 3) return "Terminado";
                },
                ellipsis: true,
                width: '25%'
            },
        ];
        return (
            <>
                <Form
                    ref={this.formRef}
                    name="reporteActividadEtapas"
                    onFinish={this.consultarReporteActividadEtapas.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <PageHeader
                        onBack={this.atras.bind(this)}
                        title="Reporte Actividad Etapas"
                        style={{
                            border: "1px solid rgb(235, 237, 240)",
                            backgroundColor: "white",
                            marginBottom: 10,
                        }}
                        extra={
                            <div style={{ display: "flex", justifyContent: "right" }}>
                                <Space>
                                    {this.state.dataReporte && (
                                        <ButtonItem
                                            blanco
                                            onClick={() => this.descargarExcel()}
                                            icon={<FileExcelOutlined />}
                                            style={{ display: "block", margin: "0 0 0 auto" }}
                                        >
                                            Descargar Excel
                                        </ButtonItem>
                                    )}
                                    {this.state.dataReporte && (
                                        <ButtonItem
                                            blanco
                                            onClick={() => this.descargarPdf()}
                                            icon={<FilePdfOutlined />}
                                            style={{ display: "block", margin: "0 0 0 auto" }}
                                        >
                                            Descargar PDF
                                        </ButtonItem>
                                    )}
                                    <ButtonItem
                                        type="primary"
                                        htmlType="submit"
                                        style={{ display: "block", margin: "0 0 0 auto" }}
                                    >
                                        Consultar
                                    </ButtonItem>
                                </Space>
                            </div>
                        }
                    />
                    <Spin spinning={this.state.loading}>
                        <div
                            style={{
                                backgroundColor: "white",
                                padding: 20,
                                paddingTop: 5,
                                borderRadius: 5,
                                marginBottom: 10,
                                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                            }}
                        >
                            <Tabs
                                style={{ margin: 0 }}
                                tabBarExtraContent={{
                                    left: (
                                        <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                                            Filtros:
                                        </h1>
                                    ),
                                }}
                            >
                                <TabPane tabKey="2" key="2" forceRender tab="Etapa">
                                    <FormItem name="etapaId" required label="Etapa">
                                        <SelectItem placeholder="Etapa" width="100%">
                                            {this.state.objetoEtapas}
                                        </SelectItem>
                                    </FormItem>
                                </TabPane>
                                <TabPane tabKey="3" key="3" forceRender tab="Periodo">
                                    <FormItem
                                        initialValue={[moment().subtract(1, "month"), moment()]}
                                        name="periodo"
                                        required
                                        noStyle
                                    >
                                        <RangePickerItem />
                                    </FormItem>
                                </TabPane>
                                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                                    <Row>
                                        <Col span={8}>
                                            <FormItem
                                                name="filtrarProyecto"
                                                required
                                                noStyle
                                                initialValue={0}
                                            >
                                                <SelectItem width="90%" placeholder="Filtrar Proyecto">
                                                    <Option default value={0}>
                                                        Niguno
                                                    </Option>
                                                    <Option value={1}>Proyectos</Option>
                                                    <Option value={2}>Unidades de negocio</Option>
                                                </SelectItem>
                                            </FormItem>
                                        </Col>
                                        <Col span={8}>
                                            <FormItem shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                    const filtrarProyecto =
                                                        getFieldValue("filtrarProyecto");
                                                    if (filtrarProyecto === 1) {
                                                        return (
                                                            <FormItem required name="proyectos" noStyle>
                                                                <SelectItem
                                                                    width="90%"
                                                                    placeholder="Proyectos"
                                                                    mode="multiple"
                                                                >
                                                                    {this.state.objetoProyectos}
                                                                </SelectItem>
                                                            </FormItem>
                                                        );
                                                    }
                                                    if (filtrarProyecto === 2) {
                                                        return (
                                                            <FormItem
                                                                required
                                                                name="unidadDeNegocioId"
                                                                noStyle
                                                            >
                                                                <SelectItem
                                                                    width="90%"
                                                                    placeholder="Unidades de Negocio"
                                                                >
                                                                    {this.state.objetoUniadesDeNegocio}
                                                                </SelectItem>
                                                            </FormItem>
                                                        );
                                                    }
                                                }}
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </TabPane>
                            </Tabs>
                        </div>
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <h1 style={{ textAlign: "center" }}>Actividades</h1>
                                <TableItem
                                    columns={columns}
                                    dataSource={this.state.todasActividades}
                                    size="small"
                                    pagination={false}
                                />
                            </Col>
                        </Row>
                    </Spin>
                </Form>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ReporteActividadEtapas);
